import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {TranslocoService} from '@jsverse/transloco';
import {GlobalService} from 'app/global/global.service';
import {IGetRecipientItem, RecipientsService} from 'app/main/pages/contacts/recipients/recipients.service';
import {take} from 'rxjs';
import {DocumentListingFacade} from '../../../store/document-listing.facade';
import {AddToContractControlFormHelper} from '../add-to-contract-control-modal.component';
import {IAutoFillUploadFile} from '../create-cc-by-ai-form/ai-cc-import.service';
import {IaiProcessedData} from '../iai-processed-data.interface';

@Component({
    selector: 'app-contacts',
    templateUrl: './contacts.component.html',
    styleUrl: './contacts.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class ContactsComponent implements OnInit, IaiProcessedData {
    @Input() mainFormGroup: FormGroup;
    @Input() aiProcessedData: IAutoFillUploadFile;

    public documentData$ = this.documentFacade$.selectedDocument$;

    constructor(
        private recipientsService: RecipientsService,
        private _formBuilder: FormBuilder,
        private globalService: GlobalService,
        private documentFacade$: DocumentListingFacade,
        private _translocoService$: TranslocoService,
        private _addToContractControlFormHelper:AddToContractControlFormHelper
    ) {
    }

    public contacts:FormArray[] = [];
    public searchedRecipient:IGetRecipientItem[] = [];
    public keyword: string = 'firstname';
    public loading: boolean = false;


    ngOnInit(): void {
        this.documentData$.pipe(take(1)).subscribe((result) => {
            if(result){
            const {template_roles} = result;
            const recipientRoles = template_roles.filter(item => {
                return item?.recipient_role_detail?.is_sender == 0;
            });
            this.contactsControl.clear(); // Clear contacts before pushing recipient
            for (const item of recipientRoles) {
                this.addContact({...item?.recipient, ...{sectionable_id: item?.recipient?.id}});
            }
        }
        });
        if(this.aiProcessedData) {
            this.initializeWithAIProcessedData(this.aiProcessedData);
        }
        
    }


    get contactsControl() {
        return this.mainFormGroup.controls['contacts'] as FormArray;
    }


    removeContact(index: number) {
        this.contactsControl.removeAt(index);
        this.contactsControl.markAsDirty();
    }


    /**
     * Search contacts
     * @param q
     */
    async searhContacts(q: string = '') {
        if (q == '') {
            return;
        }
        this.loading = true;
        this.recipientsService.fetchRecipient(1, q).subscribe(async (contract) => {
                this.searchedRecipient = contract.data || [];
                this.loading = false;
            }
        );
    }


    onClearSearch() {
        this.contacts = [];
    }


    /**
     * Get full name
     * @param contact
     * @returns fullName
     */
    getFullName(contact: FormGroup): string {
        const firstName = contact?.value?.firstname || '';
        const lastName = contact?.value?.lastname || '';
        return `${firstName} ${lastName}`.trim();
    }


    selectContact($item: IGetRecipientItem) {
        const exists = this.contactExists($item?.email);
        if (exists) {
            this.globalService.toastrError(this._translocoService$.translate('Contact already exists contact form step - Add to contract control form (Documents section - right bar) - Contact already exists'));
            return;
        }
        this.addContact({...$item, ...{sectionable_id: $item?.id}});
        this.contactsControl.markAsDirty();
    }

    initializeWithAIProcessedData(aiProcessedData: IAutoFillUploadFile): void {
        if(this.contactsControl.dirty){
            //do not ovveride list if it was changed by user
            return;
        }
        if(aiProcessedData?.recipient && Array.isArray(aiProcessedData?.recipient)) {
            aiProcessedData?.recipient?.forEach(reciepient => {
                const exists = this.contactExists(reciepient?.email);
                if (exists === false) {
                    this.addContact({
                        email: reciepient?.email,
                        firstname: reciepient?.firstname,
                        lastname: reciepient?.lastname,
                        phone_no: reciepient?.phone_no,
                        persnol_no: reciepient?.persnol_no,
                        address: reciepient?.address,
                        city: reciepient?.city,
                        zipcode: reciepient?.zipcode,
                        workspace_id: reciepient?.workspace_id,
                        user_id: reciepient?.user_id,
                        organization_id: reciepient?.organization_id,
                        profile_image: reciepient?.profile_image,
                        id: reciepient?.id,
                        sectionable_id: reciepient?.id
                    });
                }
            })
        }
    }


    private addContact(item) {
        this.contactsControl.push(this._formBuilder.group(item));
    }
    
    private contactExists(email: string): boolean {
        const contacts = this.contactsControl?.value ?? [];
        return contacts?.some(x => x.email === email);
    }

}
